import {
  Route, Routes as ReactRoutes, Navigate
} from "react-router-dom";
import Unknown from "domains/Misc/Unknown";
import Home from "domains/Home/Home";
import { Auth } from "aws-amplify";
import CreateUser from "domains/User/CreateUser/CreateUser";
import { HomeTabMode } from "interfaces/HomeTabMode";
import Unauthorised from "domains/Misc/Unauthorised";
import { UserTabMode } from "interfaces/UserTabMode";
import { useStateMachine } from "little-state-machine";

const logout = async () => {
  try {
    await Auth.signOut();
  } catch (error) {
    // console.log("error signing out: ", error);
  }
};

const HandleLogoutComponent = () => {
  logout();
  return <></>;
};

const Routes = () => {
  const { state } = useStateMachine();
  return (
    <ReactRoutes>
      <Route path="/" element={<Navigate replace to="/users" />} />
      <Route path="/users" element={<Home homeTabMode={HomeTabMode.Users} userTabMode={UserTabMode.Users} />} />
      <Route path="/requests" element={<Home homeTabMode={HomeTabMode.Requests} userTabMode={UserTabMode.Requests} />} />
      <Route
        path="/manageuser"
        element={!state.selectedUser ? <Navigate replace to="/" /> : <Home homeTabMode={HomeTabMode.Users} userTabMode={UserTabMode.ManageUser} />}
      />
      <Route
        path="/userhistory"
        element={!state.selectedUser ? <Navigate replace to="/" /> : <Home homeTabMode={HomeTabMode.Users} userTabMode={UserTabMode.UserHistory} />}
      />
      <Route path="/createuser" element={<CreateUser />} />
      <Route
        path="/manageuserapplications"
        element={!state.selectedUser ? <Navigate replace to="/" /> : <Home homeTabMode={HomeTabMode.Users} userTabMode={UserTabMode.ManageApplications} />}
      />
      <Route
        path="/manageusergroups"
        element={!state.selectedUser ? <Navigate replace to="/" /> : <Home homeTabMode={HomeTabMode.Users} userTabMode={UserTabMode.ManageUserGroups} />}
      />
      <Route
        path="/manageusermfaoptions"
        element={!state.selectedUser ? <Navigate replace to="/" /> : <Home homeTabMode={HomeTabMode.Users} userTabMode={UserTabMode.ManageMFAOptions} />}
      />
      <Route
        path="/assignuserwhitespaceroles"
        element={!state.selectedUser ? <Navigate replace to="/" />
          : <Home homeTabMode={HomeTabMode.Users} userTabMode={UserTabMode.AssignUserWhitespaceRoles} />}
      />
      <Route
        path="/assignuserwhitespaceauthorities"
        element={!state.selectedUser ? <Navigate replace to="/" />
          : <Home homeTabMode={HomeTabMode.Users} userTabMode={UserTabMode.AssignUserWhitespaceAuthorities} />}
      />
      <Route
        path="/assignuserhwrcroles"
        element={!state.selectedUser ? <Navigate replace to="/" />
          : <Home homeTabMode={HomeTabMode.Users} userTabMode={UserTabMode.AssignUserHwrcRoles} />}
      />
      <Route
        path="/assignuserhwrcregions"
        element={!state.selectedUser ? <Navigate replace to="/" />
          : <Home homeTabMode={HomeTabMode.Users} userTabMode={UserTabMode.AssignUserHwrcRegions} />}
      />
      <Route
        path="/assignuserhwrcsites"
        element={!state.selectedUser ? <Navigate replace to="/" /> : <Home homeTabMode={HomeTabMode.Users} userTabMode={UserTabMode.AssignUserHwrcSites} />}
      />
      <Route
        path="/requestsassignuserwhitespaceroles"
        element={!state.selectedUser ? <Navigate replace to="/" />
          : <Home homeTabMode={HomeTabMode.Requests} userTabMode={UserTabMode.AssignUserWhitespaceRoles} />}
      />
      <Route
        path="/requestsassignuserwhitespaceauthorities"
        element={!state.selectedUser
          ? <Navigate replace to="/" />
          : <Home homeTabMode={HomeTabMode.Requests} userTabMode={UserTabMode.AssignUserWhitespaceAuthorities} />}
      />
      <Route
        path="/requestsassignuserhwrcroles"
        element={!state.selectedUser ? <Navigate replace to="/" />
          : <Home homeTabMode={HomeTabMode.Requests} userTabMode={UserTabMode.AssignUserHwrcRoles} />}
      />
      <Route
        path="/requestsassignuserhwrcregions"
        element={!state.selectedUser ? <Navigate replace to="/" />
          : <Home homeTabMode={HomeTabMode.Requests} userTabMode={UserTabMode.AssignUserHwrcRegions} />}
      />
      <Route
        path="/requestsassignuserhwrcsites"
        element={!state.selectedUser ? <Navigate replace to="/" /> : <Home homeTabMode={HomeTabMode.Requests} userTabMode={UserTabMode.AssignUserHwrcSites} />}
      />

      <Route path="/unauthorised" element={<Unauthorised />} />
      <Route path="/logout" element={<HandleLogoutComponent />} />
      <Route path="*" element={<Unknown />} />
    </ReactRoutes>
  );
};

export default Routes;
